<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>{{ 'Phiếu đăng ký ưu đãi' }}</h1>
      <div class="float-right">
        <button
          type="button"
          @click="cancelMerchantKeyOnus(dataRequest.id)"
          class="btn btn-light ml-2"
          v-if="dataRequest.status && dataRequest.status == 'NEW'"
        >
          Hủy
        </button>
        <button
          type="button"
          @click="$router.push(`/preferential-merchant-registration/edit/${dataRequest.id}`)"
          class="btn btn-light ml-2"
          v-if="dataRequest.status && optionStatusCanEdit.includes(dataRequest.status)"
        >
          Sửa
        </button>
        <button
          type="button"
          @click="sendManagerMerchantKeyOnus"
          class="btn btn-light ml-2"
          v-if="dataRequest.status && dataRequest.status == 'NEW'"
        >
          Chuyển chờ duyệt
        </button>
        <button
          type="button"
          @click="managerRejectMerchantKeyOnus(dataRequest.id)"
          class="btn btn-light ml-2"
          v-if="dataRequest.status && dataRequest.status == 'AWAITING_MANAGER_APPROVAL'"
        >
          Từ chối
        </button>
        <button
          type="button"
          @click="managerRequestAddMerchantKeyOnus(dataRequest.id)"
          class="btn btn-light ml-2"
          v-if="dataRequest.status && dataRequest.status == 'AWAITING_MANAGER_APPROVAL'"
        >
          Yêu cầu bổ sung
        </button>
        <button
          type="button"
          @click="managerApprovalMerchantKeyOnus(dataRequest.id)"
          class="btn btn-light ml-2"
          v-if="dataRequest.status && dataRequest.status == 'AWAITING_MANAGER_APPROVAL'"
        >
          Duyệt, chuyển VH
        </button>
        <button
          type="button"
          @click="operationPleaseAdviseAddMerchantKeyOnus(dataRequest.id)"
          class="btn btn-light ml-2"
          v-if="dataRequest.status && dataRequest.status == 'AWAITING_OPERATION_APPROVAL'"
        >
          Xin ý kiến GĐV
        </button>
        <button
          type="button"
          @click="operationRequestAddAddMerchantKeyOnus(dataRequest.id)"
          class="btn btn-light ml-2"
          v-if="dataRequest.status && dataRequest.status == 'AWAITING_OPERATION_APPROVAL'"
        >
          Yêu cầu bổ sung
        </button>
        <button
          type="button"
          @click="operationApprovalMerchantKeyOnus(dataRequest.id)"
          class="btn btn-light ml-2"
          v-if="dataRequest.status && dataRequest.status == 'AWAITING_OPERATION_APPROVAL'"
        >
          Duyệt
        </button>
        <button
          type="button"
          @click="showModalAdditionalFile()"
          class="btn btn-light ml-2"
          v-if="
            dataRequest.status &&
            dataRequest.status == 'OPERATION_APPROVED' &&
            dataRequest.additionalStatus &&
            dataRequest.additionalStatus == 'NEED_ADDITIONAL_INFO_LATER'
          "
        >
          Bổ sung hồ sơ
        </button>
        <button
          type="button"
          @click="operationApprovalAddMerchantKeyOnus(dataRequest.id)"
          class="btn btn-light ml-2"
          v-if="
            dataRequest.status &&
            dataRequest.status == 'OPERATION_APPROVED' &&
            dataRequest.additionalStatus &&
            dataRequest.additionalStatus == 'WAIT_APPROVE_ADDITION'
          "
        >
          Duyệt BS theo cam kết
        </button>
        <button
          type="button"
          @click="operationRejectAddMerchantKeyOnus(dataRequest.id)"
          class="btn btn-light ml-2"
          v-if="
            dataRequest.status &&
            dataRequest.status == 'OPERATION_APPROVED' &&
            dataRequest.additionalStatus &&
            dataRequest.additionalStatus == 'WAIT_APPROVE_ADDITION'
          "
        >
          Từ chối BS theo cam kết
        </button>
      </div>
    </div>

    <div class="card p-10 pt-15" style="overflow-x: hidden; overflow-y: auto">
      <div class="card-body px-20 row">
        <div class="col-md-6">
          <div class="m-b-10" style="border: 1px solid"></div>
          <TicketInfo ref="ticketInfoRef" />
          <div class="m-b-10" style="border: 1px solid"></div>
          <div>
            <h6>Điều kiện MC key</h6>
            <div class="form-group row">
              <label class="col-sm-3 col-form-label"> Ngành nghề </label>
              <div class="col-sm-9 p-m-5">
                <p>
                  {{
                    dataRequest.industry
                      ? joinArrayData(dataRequest.industry, systemConfig.businessFields)
                      : ''
                  }}
                </p>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-3 col-form-label"> NN chi tiết </label>
              <div class="col-sm-9 p-m-5">
                <p>
                  {{
                    dataRequest.detailedIndustry
                      ? joinArrayData(dataRequest.detailedIndustry, optionBusinessDetail)
                      : ''
                  }}
                </p>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-sm-3 col-form-label"> NN chi tiết (khác) </label>
              <div class="col-sm-9 p-m-5">
                <p>
                  {{ dataRequest.otherDetailedIndustry ? dataRequest.otherDetailedIndustry : '' }}
                </p>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-3 col-form-label"> Doanh số </label>
              <div class="col-sm-9 p-m-5">
                <p v-if="dataRequest.revenue">{{ dataRequest.revenue | transformMoney }}</p>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-3 col-form-label"> Số cửa hàng </label>
              <div class="col-sm-9 p-m-5">
                <p>{{ dataRequest.numberOfStore ? dataRequest.numberOfStore : '' }}</p>
              </div>
            </div>
            <div class="form-group row">
              <label for="" class="col-sm-3 col-form-label">Ghi chú LQ MC Key</label>
              <div class="col-sm-9 p-m-5">
                <p>{{ dataRequest.mcKeyNote ? dataRequest.mcKeyNote : '' }}</p>
              </div>
            </div>
          </div>
          <div class="m-b-10" style="border: 1px solid"></div>
          <div>
            <h6>Hồ sơ chính</h6>
            <div class="form-group row">
              <label class="col-sm-3 col-form-label"> Hình thức KD </label>
              <div class="col-sm-9 p-m-5">
                <p>
                  {{
                    dataRequest.businessForm
                      ? joinArrayData(dataRequest.businessForm, systemConfig.businessField)
                      : ''
                  }}
                </p>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-3 col-form-label"> Thương hiệu </label>
              <div class="col-sm-9 p-m-5">
                <p>{{ dataRequest.brand ? dataRequest.brand : '' }}</p>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-3 col-form-label"> Sở hữu thương hiệu </label>
              <div class="col-sm-9 p-m-5">
                <p>
                  {{
                    dataRequest.brandOwnership
                      ? joinArrayData(dataRequest.brandOwnership, optionBrandOwnerShip)
                      : ''
                  }}
                </p>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-3 col-form-label"> Loại tài khoản ngân hàng </label>
              <div class="col-sm-9 p-m-5">
                <p>
                  {{
                    dataRequest.bankAccountType
                      ? joinArrayData(dataRequest.bankAccountType, optionBankAccountType)
                      : ''
                  }}
                </p>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-3 col-form-label"> Link website </label>
              <div class="col-sm-9 p-m-5">
                <p>{{ dataRequest.websiteLink ? dataRequest.websiteLink : '' }}</p>
              </div>
            </div>
            <div class="form-group row">
              <label for="" class="col-sm-3 col-form-label">Ghi chú LQ HS chính</label>
              <div class="col-sm-9 p-m-5">
                <p>{{ dataRequest.mainProfileNote ? dataRequest.mainProfileNote : '' }}</p>
              </div>
            </div>
            <div class="form-group row">
              <label for="" class="col-sm-3 col-form-label">Link hợp đồng</label>
              <div class="col-sm-9 p-m-5">
                <b-button @click.prevent="openLinkContract">Xem hợp đồng</b-button>
              </div>
            </div>
            <div class="form-group row">
              <label for="" class="col-sm-3 col-form-label">Ảnh CCCD</label>
              <div class="col-sm-9">
                <div class="form-group img-list" v-if="dataRequest.idCardImage">
                  <ul class="m-0" v-viewer>
                    <li v-for="(item, index) in dataRequest.idCardImage" :key="index">
                      <a href="javascript:void(0)">
                        <img :src="item" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label for="" class="col-sm-3 col-form-label">Ảnh ĐKKD</label>
              <div class="col-sm-9">
                <div class="form-group img-list" v-if="dataRequest.businessLicenseImage">
                  <ul class="m-0" v-viewer>
                    <li v-for="(item, index) in dataRequest.businessLicenseImage" :key="index">
                      <a href="javascript:void(0)">
                        <img :src="item" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label for="" class="col-sm-3 col-form-label">Ảnh LQ thương hiệu</label>
              <div class="col-sm-9">
                <div class="form-group img-list" v-if="dataRequest.brandRelatedImage">
                  <ul class="m-0" v-viewer>
                    <li v-for="(item, index) in dataRequest.brandRelatedImage" :key="index">
                      <a href="javascript:void(0)">
                        <img :src="item" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label for="" class="col-sm-3 col-form-label">GP hoạt động</label>
              <div class="col-sm-9">
                <div class="form-group img-list" v-if="dataRequest.operatingLicense">
                  <ul class="m-0" v-viewer>
                    <li v-for="(item, index) in dataRequest.operatingLicense" :key="index">
                      <a href="javascript:void(0)">
                        <img :src="item" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label for="" class="col-sm-3 col-form-label">Hóa đơn bán hàng</label>
              <div class="col-sm-9">
                <div class="form-group img-list" v-if="dataRequest.salesInvoiceImage">
                  <ul class="m-0" v-viewer>
                    <li v-for="(item, index) in dataRequest.salesInvoiceImage" :key="index">
                      <a href="javascript:void(0)">
                        <img :src="item" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="m-b-10" style="border: 1px solid"></div>
          <div>
            <h6>Tài khoản ngân hàng</h6>
            <div class="form-group row">
              <label class="col-sm-3 col-form-label"> Loại TKNH </label>
              <div class="col-sm-9 p-m-5">
                <p>
                  {{
                    dataRequest.merchant && dataRequest.merchant.bankAccType
                      ? joinArrayData(dataRequest.merchant.bankAccType, optionBankAccountType)
                      : ''
                  }}
                </p>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-3 col-form-label"> Người thụ hưởng </label>
              <div class="col-sm-9 p-m-5">
                <p>
                  {{
                    dataRequest.merchant && dataRequest.merchant.holderName
                      ? dataRequest.merchant.holderName
                      : ''
                  }}
                </p>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-3 col-form-label">Số tài khoản </label>
              <div class="col-sm-9 p-m-5">
                <p>
                  {{
                    dataRequest.merchant && dataRequest.merchant.accountNo
                      ? dataRequest.merchant.accountNo
                      : ''
                  }}
                </p>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-3 col-form-label">Ngân hàng </label>
              <div class="col-sm-9 p-m-5">
                <p>
                  {{
                    dataRequest.merchant && dataRequest.merchant.bankName
                      ? dataRequest.merchant.bankName
                      : ''
                  }}
                </p>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-3 col-form-label">Chi nhánh </label>
              <div class="col-sm-9 p-m-5">
                <p>
                  {{
                    dataRequest.merchant && dataRequest.merchant.branch
                      ? dataRequest.merchant.branch
                      : ''
                  }}
                </p>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-3 col-form-label">Tỉnh thành TKNH </label>
              <div class="col-sm-9 p-m-5">
                <p>
                  {{
                    dataRequest.merchant && dataRequest.merchant.bankCityCode
                      ? joinArrayData(dataRequest.merchant.bankCityCode, dataCity)
                      : ''
                  }}
                </p>
              </div>
            </div>
          </div>
          <div v-if="dataRequest.businessAddress">
            <h6>Danh sách cửa hàng</h6>
            <div v-for="(item, index) in dataRequest.businessAddress">
              <div class="m-b-10" style="border: 1px solid; padding: 8px" :key="index">
                <div class="m-b-10" style="display: flex">
                  <span class="mr-auto">ĐCNTT</span>
                </div>
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label"> Tên cửa hàng </label>
                  <div class="col-sm-9 p-m-5">
                    <p>
                      {{
                        dataRequest.businessAddress[index].name
                          ? dataRequest.businessAddress[index].name
                          : ''
                      }}
                    </p>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label"> Địa chỉ </label>
                  <div class="col-sm-9 p-m-5">
                    <p>
                      {{
                        dataRequest.businessAddress[index].address
                          ? dataRequest.businessAddress[index].address
                          : ''
                      }}
                    </p>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label"> Tỉnh thành </label>
                  <div class="col-sm-9 p-m-5">
                    <p>
                      {{
                        dataRequest.businessAddress[index].provinceId
                          ? joinArrayData(dataRequest.businessAddress[index].provinceId, dataCity)
                          : ''
                      }}
                    </p>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label"> Quận huyện </label>
                  <div class="col-sm-9 p-m-5">
                    <p>
                      {{
                        dataRequest.businessAddress[index].districtId
                          ? joinArrayData(
                              dataRequest.businessAddress[index].districtId,
                              dataDistict
                            )
                          : ''
                      }}
                    </p>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-3 col-form-label">Ảnh liên quan</label>
                  <div class="col-sm-9">
                    <div class="form-group img-list">
                      <ul class="m-0" v-viewer v-if="dataRequest.businessAddress[index].images">
                        <li
                          v-for="(item, index) in dataRequest.businessAddress[index].images"
                          :key="index"
                        >
                          <a href="javascript:void(0)">
                            <img :src="item" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="m-b-10 m-t-20" style="border: 1px solid"></div>
          <div>
            <h6>Đăng ký ON-US</h6>
            <div class="form-group row">
              <label class="col-sm-3 col-form-label"> Bank ĐK ON-US </label>
              <div class="col-sm-9 p-m-5">
                <p>
                  {{
                    dataRequest.bankRegisteredWithONUS
                      ? dataRequest.bankRegisteredWithONUS.join(', ')
                      : ''
                  }}
                </p>
              </div>
            </div>
            <div class="form-group row">
              <label for="" class="col-sm-3 col-form-label">Ghi chú LQ ON-US</label>
              <div class="col-sm-9 p-m-5">
                <p>{{ dataRequest.onusNote ? dataRequest.onusNote : '' }}</p>
              </div>
            </div>
          </div>
          <div class="m-b-10 m-t-20" style="border: 1px solid"></div>
          <div>
            <h6>Cam kết bổ sung</h6>

            <div class="form-group row">
              <label class="col-sm-3 col-form-label"> Trạng thái bổ sung </label>
              <div class="col-sm-9 p-m-5">
                <p>
                  {{
                    dataRequest.additionalStatus
                      ? joinArrayData(dataRequest.additionalStatus, optionAdditionalStatus)
                      : ''
                  }}
                </p>
              </div>
            </div>
            <div>
              <div class="form-group row">
                <label class="col-sm-3 col-form-label"> Thời gian bổ sung </label>
                <div class="col-sm-9 p-m-5">
                  <p v-if="dataRequest.additionalTime">
                    {{ dataRequest.additionalTime | formatDatePicker }}
                  </p>
                </div>
              </div>

              <div class="form-group row">
                <label for="" class="col-sm-3 col-form-label">Ghi chú cam kết bổ sung sau:</label>
                <div class="col-sm-9 p-m-5">
                  <p>
                    {{
                      dataRequest.additionalCommitmentNote
                        ? dataRequest.additionalCommitmentNote
                        : ''
                    }}
                  </p>
                </div>
              </div>
              <div class="form-group row">
                <label for="" class="col-sm-3 col-form-label">Ảnh BS cam kết</label>
                <div class="col-sm-9">
                  <div class="form-group img-list" v-if="dataRequest.additionalImg">
                    <ul class="m-0" v-viewer>
                      <li v-for="(item, index) in dataRequest.additionalImg" :key="index">
                        <a href="javascript:void(0)">
                          <img :src="item" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="m-b-10" style="border: 1px solid"></div>
          <div class="form-group">
            <h6>Ghi chú duyệt</h6>
            <div class="form-group row">
              <label for="" class="col-sm-3">Ghi chú của VH</label>
              <div class="col-sm-9">
                <span>{{ dataRequest.operationNote }}</span>
              </div>
            </div>
            <div class="form-group row">
              <label for="" class="col-sm-3">Ghi chú của GĐV</label>
              <div class="col-sm-9">
                <span>{{ dataRequest.regionDirectorNote }}</span>
              </div>
            </div>
          </div>
          <div class="m-b-10" style="border: 1px solid"></div>
          <HistoryAction ref="historyActionRef" />
        </div>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
    <PopupAdditionalFile ref="popupAdditionalFileRef" @success="applyAdditionalFile" />
  </div>
</template>
<script>
  import { StaffService } from '@/services/staff.service'
  import { ContractService } from '@/services/contract.service'
  import { CommonService } from '@/services/common.service'
  import PopupAdditionalFile from './component/PopupAdditionalFile.vue'
  import HistoryAction from './component/historyAction.vue'
  import mxActions from '../mxActions'
  import Config from '@/thirdParty/config'
  import TicketInfo from './component/ticketInfo.vue'

  export default {
    components: { PopupAdditionalFile, HistoryAction, TicketInfo },
    mixins: [mxActions],
    data() {
      return {
        dataRequest: {
          id: this.$route.params.id ?? '',
        },
        dataCity: [],
        systemConfig: {
          baseMccDetail: [],
          businessFields: [],
          businessField: [],
          baseMccDetail: [],
        },
        optionAdditionalStatus: [
          { id: 'NO_ADDITIONAL_INFO_NEEDED', text: 'Không cần bổ sung' },
          { id: 'NEED_ADDITIONAL_INFO_LATER', text: 'Cần bổ sung sau' },
          { id: 'WAIT_APPROVE_ADDITION', text: 'Chờ duyệt bổ sung' },
          { id: 'OPERATION_APPROVED', text: 'Đã đủ hồ sơ' },
        ],
        optionType: [
          { id: 'MC_KEY', text: 'Merchant key' },
          { id: 'MC_KEY_ONUS', text: 'Merchant key + onus' },
        ],
        showLoading: false,
        optionStatus: [
          { id: 'NEW', text: 'Mới tạo' },
          { id: 'AWAITING_MANAGER_APPROVAL', text: 'Chờ GĐV duyệt' },
          { id: 'MANAGER_REJECTED', text: 'Từ chối' },
          { id: 'MANAGER_REQUESTED_ADDITIONAL', text: 'GĐV YC Bổ sung' },
          { id: 'AWAITING_OPERATION_APPROVAL', text: 'Chờ VH duyệt' },
          { id: 'OPERATION_REQUESTED_EDIT', text: 'VH yêu cầu bổ sung' },
          { id: 'OPERATION_APPROVED', text: 'VH đã duyệt' },
          { id: 'CANCELED', text: 'Đã huỷ' },
        ],
        optionBusinessDetail: [],
        optionStatusCanEdit: ['NEW', 'MANAGER_REQUESTED_ADDITIONAL', 'OPERATION_REQUESTED_EDIT'],
        optionBankAccountType: Config.mcBankAccType,
        optionBrandOwnerShip: Config.mcKeyOwnerType,
      }
    },
    computed: {
      joinArrayData() {
        return (item, options) => {
          const mapData = options.find(e => e.id === item)
          return mapData ? mapData.text : ''
        }
      },
      mapData() {
        return (option, id = 'code', text = 'name') => {
          return option.map(e => ({ id: e[id], text: e[text] }))
        }
      },
      getColor() {
        return (code, option) => {
          if (!code) return code
          return option[code] ? option[code] : code
        }
      },
    },
    async created() {
      await StaffService.getDistictByCode({})
        .then(s => s.data?.map(s => ({ id: s.code, text: s.name })) ?? [])
        .then(s => (this.dataDistict = s))
      await this.queryProvince()
      await this.getConfigSystem()
      await this.fetchData()
      await this.getContractLink()
    },
    methods: {
      async fetchData() {
        if (this.dataRequest.id) {
          try {
            this.showLoading = true
            const response = await ContractService.detailMerchantKeyOnus({
              id: this.dataRequest.id,
            })
            if (response.success) {
              const mapData = response.data
              if (mapData.data) {
                this.dataRequest = mapData.data
                await this.selectedBusiness()
                this.$refs.historyActionRef?.show(this.dataRequest.id)
                this.$refs.ticketInfoRef?.show(this.dataRequest, this.dataRequest.merchant)
              }
            } else {
              this.showFailMx(response.message)
            }
          } catch (e) {
            this.showFailMx(e.message ?? e)
          } finally {
            this.showLoading = false
          }
        }
      },
      async queryProvince() {
        try {
          const data = await StaffService.getAllCity({})
          if (data.code === 1000) {
            this.dataCity = data.data.map(e => {
              return { id: e.code, text: e.name }
            })
          }
        } catch (error) {}
      },
      getConfigSystem() {
        return CommonService.getConfigSystem()
          .then(data => {
            if (data.success) {
              const config = data.data ? data.data : []
              this.systemConfig = {
                businessFields: config.businessFields ? this.mapData(config.businessFields) : [],
                businessField: config.businessField
                  ? config.businessField.map(e => ({ id: e, text: e }))
                  : [],
                posBankIssuer: config.posBankIssuer
                  ? this.mapData(config.posBankIssuer, 'code', 'code')
                  : [],
                baseMccDetail: config.mccDetail ? config.mccDetail : [],
              }
            }
          })
          .catch(error => this.showFailMx(error.message ?? error))
      },
      async selectedBusiness() {
        const mapData = this.systemConfig.baseMccDetail.find(
          items => items.code == this.dataRequest.industry
        )
        if (mapData) {
          this.optionBusinessDetail = mapData.detail
            ? mapData.detail.reduce((acc, current) => {
                acc.push({ id: current, text: current })
                return acc
              }, [])
            : []
        }
      },
      showModalAdditionalFile() {
        this.$refs.popupAdditionalFileRef.show(this.dataRequest)
      },
      async sendManagerMerchantKeyOnus() {
        try {
          this.showLoading = true
          const response = await ContractService.sendManagerMerchantKeyOnus({
            id: this.dataRequest.id,
          })
          if (response.success) {
            this.showSuccessMx('Thành công')
            location.reload()
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },
      async getContractLink() {
        try {
          this.showLoading = true
          const params = {
            page: 1,
            limit: 15,
            customerId:
              this.dataRequest.merchant && this.dataRequest.merchant.id
                ? this.dataRequest.merchant.id
                : 1,
            groupService: 'PAYMENT',
            serviceTypes: ['MPOS'],
          }
          const response = await ContractService.getListContract(params)
          if (response.success) {
            const mapData = response.data
            if (mapData.contractList && mapData.contractList.length > 0) {
              this.dataRequest.contractHistoryOne = mapData.contractList[0] ?? {}
            }
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },
      openLinkContract() {
        if (
          this.dataRequest.contractHistoryOne &&
          Object.keys(this.dataRequest.contractHistoryOne).length > 0
        ) {
          const contract = this.dataRequest.contractHistoryOne

          if (contract.groupService === 'SELL') {
            if (contract.formContract === 'E_CONTRACT') {
              window.open(`/sales-manager/detail/${encodeURIComponent(contract.id)}`, '_blank')
            } else {
              window.open(
                `/sales-manager/detail-paper/${encodeURIComponent(contract.id)}`,
                '_blank'
              )
            }
          } else {
            if (contract.formContract === 'E_CONTRACT') {
              window.open(`/contract-detail-ecommerce/${encodeURIComponent(contract.id)}`, '_blank')
            } else {
              window.open(`/contract-detail-paper/${encodeURIComponent(contract.id)}`, '_blank')
            }
          }
        } else {
          this.showFailMx('Không có hợp đồng')
        }
      },
      async cancelMerchantKeyOnus(id) {
        try {
          const flag = await this.showModalTextMerchantKeyOnus(
            'Bạn có chắc chắn huỷ phiếu đăng ký ưu đãi',
            'Huỷ phiếu'
          )
          if (flag !== true) return
          this.showLoading = true
          const params = {
            id,
          }

          const response = await ContractService.cancelMerchantKeyOnus(params)
          if (response.code === 1000) {
            await this.fetchData()
            this.$refs.historyActionRef?.show(this.dataRequest.id)
            this.showSuccessMx('Thành công')
          } else {
            this.showFailMx(response.message ?? response.error)
          }
        } catch (error) {
          this.showFailMx(error)
        } finally {
          this.showLoading = false
        }
      },
      async managerRejectMerchantKeyOnus(id) {
        try {
          const { value: flag, note } = await this.showModalNoteMerchantKeyOnus(
            'Ghi chú của GĐV',
            'Từ chối phiếu đăng ký ưu đãi'
          )
          if (flag !== true) return
          this.showLoading = true
          const params = {
            id,
            note,
          }

          const response = await ContractService.managerRejectMerchantKeyOnus(params)
          if (response.code === 1000) {
            await this.fetchData()
            this.$refs.historyActionRef?.show(this.dataRequest.id)
            this.showSuccessMx('Thành công')
          } else {
            this.showFailMx(response.message ?? response.error)
          }
        } catch (error) {
          this.showFailMx(error)
        } finally {
          this.showLoading = false
        }
      },
      async managerApprovalMerchantKeyOnus(id) {
        try {
          const { value: flag, note } = await this.showModalNoteMerchantKeyOnus(
            'Ghi chú của GĐV',
            'GĐV duyệt, chuyển VH'
          )
          if (flag !== true) return
          this.showLoading = true
          const params = {
            id,
            note,
          }

          const response = await ContractService.managerApprovalMerchantKeyOnus(params)
          if (response.code === 1000) {
            await this.fetchData()
            this.$refs.historyActionRef?.show(this.dataRequest.id)
            this.showSuccessMx('Thành công')
          } else {
            this.showFailMx(response.message ?? response.error)
          }
        } catch (error) {
          this.showFailMx(error)
        } finally {
          this.showLoading = false
        }
      },
      async managerRequestAddMerchantKeyOnus(id) {
        try {
          const { value: flag, note } = await this.showModalNoteMerchantKeyOnus(
            'Ghi chú của GĐV',
            'Yêu cầu bổ sung'
          )
          if (flag !== true) return
          this.showLoading = true
          const params = {
            id,
            note,
          }

          const response = await ContractService.managerRequestAddMerchantKeyOnus(params)
          if (response.code === 1000) {
            await this.fetchData()
            this.$refs.historyActionRef?.show(this.dataRequest.id)
            this.showSuccessMx('Thành công')
          } else {
            this.showFailMx(response.message ?? response.error)
          }
        } catch (error) {
          this.showFailMx(error)
        } finally {
          this.showLoading = false
        }
      },
      async operationPleaseAdviseAddMerchantKeyOnus(id) {
        try {
          const { value: flag, note } = await this.showModalNoteMerchantKeyOnus(
            'Ghi chú của VH',
            'Xin ý kiến GĐV'
          )
          if (flag !== true) return
          this.showLoading = true
          const params = {
            id,
            note,
          }

          const response = await ContractService.operationPleaseAdviseAddMerchantKeyOnus(params)
          if (response.code === 1000) {
            await this.fetchData()
            this.$refs.historyActionRef?.show(this.dataRequest.id)
            this.showSuccessMx('Thành công')
          } else {
            this.showFailMx(response.message ?? response.error)
          }
        } catch (error) {
          this.showFailMx(error)
        } finally {
          this.showLoading = false
        }
      },
      async operationRequestAddAddMerchantKeyOnus(id) {
        try {
          const { value: flag, note } = await this.showModalNoteMerchantKeyOnus(
            'Ghi chú của VH',
            'Yêu cầu bổ sung'
          )
          if (flag !== true) return
          this.showLoading = true
          const params = {
            id,
            note,
          }

          const response = await ContractService.operationRequestAddAddMerchantKeyOnus(params)
          if (response.code === 1000) {
            await this.fetchData()
            this.$refs.historyActionRef?.show(this.dataRequest.id)
            this.showSuccessMx('Thành công')
          } else {
            this.showFailMx(response.message ?? response.error)
          }
        } catch (error) {
          this.showFailMx(error)
        } finally {
          this.showLoading = false
        }
      },
      async operationApprovalMerchantKeyOnus(id) {
        try {
          const flag = await this.showModalTextMerchantKeyOnus(
            'Bạn có chắc chắn duyệt phiếu đăng ký ưu đãi',
            'VH duyệt'
          )
          if (flag !== true) return
          this.showLoading = true
          const params = {
            id,
          }

          const response = await ContractService.operationApprovalMerchantKeyOnus(params)
          if (response.code === 1000) {
            await this.updateMerchantKey()
            await this.fetchData()
            this.$refs.historyActionRef?.show(this.dataRequest.id)
            this.showSuccessMx('Thành công')
          } else {
            this.showFailMx(response.message ?? response.error)
          }
        } catch (error) {
          this.showFailMx(error)
        } finally {
          this.showLoading = false
        }
      },
      async operationRejectAddMerchantKeyOnus(id) {
        try {
          const { value: flag, note } = await this.showModalNoteMerchantKeyOnus(
            'Ghi chú của VH',
            'Từ chối BS theo cam kết'
          )
          if (flag !== true) return
          this.showLoading = true
          const params = {
            id,
            note,
          }

          const response = await ContractService.operationRejectAddMerchantKeyOnus(params)
          if (response.code === 1000) {
            await this.fetchData()
            this.$refs.historyActionRef?.show(this.dataRequest.id)
            this.showSuccessMx('Thành công')
          } else {
            this.showFailMx(response.message ?? response.error)
          }
        } catch (error) {
          this.showFailMx(error)
        } finally {
          this.showLoading = false
        }
      },
      async operationApprovalAddMerchantKeyOnus(id) {
        try {
          const flag = await this.showModalTextMerchantKeyOnus(
            'Bạn có chắc chắn duyệt duyệt phần BS theo cam kết',
            'VH duyệt phần BS theo cam kết'
          )
          if (flag !== true) return
          this.showLoading = true
          const params = {
            id,
          }

          const response = await ContractService.operationApprovalAddMerchantKeyOnus(params)
          if (response.code === 1000) {
            await this.fetchData()
            this.$refs.historyActionRef?.show(this.dataRequest.id)
            this.showSuccessMx('Thành công')
          } else {
            this.showFailMx(response.message ?? response.error)
          }
        } catch (error) {
          this.showFailMx(error)
        } finally {
          this.showLoading = false
        }
      },
      async applyAdditionalFile() {
        await this.fetchData()
        this.$refs.historyActionRef?.show(this.dataRequest.id)
      },
      async updateMerchantKey() {
        try {
          this.showLoading = true
          const params = {
            customerId: this.dataRequest.merchant.id,
            mcLvl: 'MC_KEY',
            brand: this.dataRequest.brand,
            brandOwnerType: this.dataRequest.brandOwnership,
            bankAccType: this.dataRequest.bankAccountType,
          }

          const response = await ContractService.updateMerchantKeyToNormal(params)
          if (response.code === 1000) {
            // this.showSuccessMx('Thành công')
          } else {
            this.showFailMx(response.message ?? response.error)
          }
        } catch (error) {
          this.showFailMx(error)
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>
<style scoped>
  .p-m-5 {
    padding: 5px;
  }
</style>
